import React, { useEffect, useState } from 'react'
import Radium, { StyleRoot } from 'radium'
import { useDispatch, useSelector } from 'react-redux'
import get from 'lodash.get'
import { slideOutLeft, slideInLeft, fadeIn } from 'react-animations'
import { Button, Tabs } from 'antd'

import { fetchLoadById } from '../../../LoadsDetails/actions'
import { formatHash } from '../../../../utils/stringFormatter'

import Client from './components/Client'
import LogisticOperator from './components/LogisticOperator'
import css from './index.scss'

const ButtonGroup = Button.Group

const TabPane = Tabs.TabPane

const DeliverConfirmModal = ({ hashId, deliveryId, shippingType, onCloseClick, isClient }) => {
  const dispatch = useDispatch()
  const load = useSelector((state) =>
    get(state, `loadsDetails.mappedLoadsDetailsByHash[${formatHash(hashId)}]`, null)
  )
  const [animation, setAnimation] = useState({
    animation: 'x 300ms',
    animationName: Radium.keyframes(slideInLeft, 'slideInLeft'),
  })
  const [fadeInContainer] = useState({
    animation: 'x 300ms',
    animationName: Radium.keyframes(fadeIn, 'fadeIn'),
  })

  const handleCloseAnimation = () => {
    setAnimation({
      animation: 'x 300ms',
      animationName: Radium.keyframes(slideOutLeft, 'slideOutLeft'),
    })
    onCloseClick()
  }

  useEffect(() => {
    if (hashId && deliveryId) {
      dispatch(fetchLoadById(hashId, shippingType === 'LOT' ? deliveryId : null))
    }
  }, [hashId, deliveryId, dispatch])

  if (!load) return null

  return (
    <StyleRoot>
      <div style={[fadeInContainer]} className={css.fullContainer}>
        <div
          onClick={handleCloseAnimation}
          tabIndex={0}
          role="button"
          style={{ height: '100%', cursor: 'default' }}
        />
        <div className={css.container} style={[animation]}>
          <div className={css.content}>
            <div style={{ position: 'absolute', right: 16, top: 18 }}>
              <ButtonGroup size="small">
                <Button type="primary" icon="close" onClick={handleCloseAnimation} />
              </ButtonGroup>
            </div>
            <span className={css.title}>
              {isClient ? 'Confirmar entrega' : 'Confirmar entrega(s)'}
            </span>
            <div className={css.bar} />
            {load && !!load.shipper.canSendToLogisticOperator && !isClient ? (
              <Tabs defaultActiveKey=".$1" onChange={(key) => console.log(key)}>
                <TabPane tab="Cliente" key="1">
                  <Client load={load} onCloseClick={handleCloseAnimation} />
                </TabPane>
                <TabPane tab="Operador" key="2">
                  <LogisticOperator load={load} onCloseClick={handleCloseAnimation} />
                </TabPane>
              </Tabs>
            ) : (
              <Client load={load} onCloseClick={handleCloseAnimation} isClient={isClient} />
            )}
          </div>
        </div>
      </div>
    </StyleRoot>
  )
}

export default DeliverConfirmModal
